import { render, staticRenderFns } from "./SetupInstallation.vue?vue&type=template&id=f4104c78&scoped=true&"
import script from "./SetupInstallation.vue?vue&type=script&lang=ts&"
export * from "./SetupInstallation.vue?vue&type=script&lang=ts&"
import style0 from "./SetupInstallation.vue?vue&type=style&index=0&id=f4104c78&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4104c78",
  null
  
)

export default component.exports